import Hooks from "@hooks";
import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import { Form } from "@components";
import { Delete as DeleteIcon } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import {
  ApproversResponse,
  Employee,
  getEmployeeByEmail,
  UpdateApprovers,
  updateApproversRequest,
  removeApproverRequest,
} from "@api";
import { CardWrapper, Modal } from "@components";
import { useApproverDistroSelect } from "@hooks";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import api from "@api";
import { Field } from "../../../../../components/form/fields/field";
import { alertService } from "@services";
import { approverDistro } from "@api/admin/approverdistro";

const useStyles = makeStyles({
  dialog: {
    borderLeft: "3px solid #F1B66A",
  },
  icon: {
    position: "absolute",
    right: "1px",
    top: "1px",
    color: "black",
  },
  dialogContent: {
    width: "880px",
    height: "560px",
  },
});

interface Props {
  isOpen: boolean;
  closeModal?: () => void;
  onUpdate: () => void;
  approvers: ApproversResponse;
  headerId: number;
  userEmail: string | null;
}

type FormValues = {
  id: number;
  approver1: string | null;
  approvalDistroName1: string;
  approver2: string | null;
  approvalDistroName2: string;
  approver3: string | null;
  approvalDistroName3: string;
  approver4: string | null;
  approvalDistroName4: string;
  approverDistro2: number;
  approverDistro3: number;
  approverDistro4: number;
};

type Key = keyof FormValues;

export const UpdateApprover: React.FC<Props> = ({
  isOpen,
  closeModal = () => {},
  approvers,
  headerId,
  userEmail,
  onUpdate,
}) => {
  const classNames = useStyles();
  const title = `Update Approvers`;
  const {
    approver1,
    approvalDistroName1,
    approvedBy1,
    approver2,
    approvalDistroName2,
    approvedBy2,
    approver3,
    approvalDistroName3,
    approvedBy3,
    approver4,
    approvalDistroName4,
    approvedBy4,
  } = approvers;

  useEffect(() => {
    return () => {
      console.log("Unmounting");
    };
  }, []);

  const form = Form.useManager<FormValues>({
    id: headerId,
    approver1: "",
    approvalDistroName1: "",
    approver2: "",
    approvalDistroName2: "",
    approver3: "",
    approvalDistroName3: "",
    approver4: "",
    approvalDistroName4: "",
    approverDistro2: approvers ? approvers.approverDistro2 : 0,
    approverDistro3: approvers ? approvers.approverDistro3 : 0,
    approverDistro4: approvers ? approvers.approverDistro4 : 0,
  });

  useEffect(() => {
    console.log("newly rendered");
    console.log("approverDistro2: "+approvers.approverDistro2);
    console.log("approverDistro2: "+form.values.approverDistro2);
  }, [approvers]);

  const initial_values = approvers;
  const [values, setValues] = React.useState<ApproversResponse | undefined>(
    initial_values
  );

  const {
    approverDistros,
    isFetchingApproverDistros,
    selectedApproverDistro2,
    selectedApproverDistro3,
    selectedApproverDistro4,
    setSelectedApproverDistro2,
    setSelectedApproverDistro3,
    setSelectedApproverDistro4,
    //handleApproverDistroTypeChange
  } = useApproverDistroSelect(
    null,
    form.values.approverDistro2,
    form.values.approverDistro3,
    form.values.approverDistro4
  );

  const [userDetails, setUserDetails] = useState<Employee>();


  useEffect(() => {
    if (approvers) {
      console.log("approver2 - "+approvers.approver2);
      if (approvers.approver2 === "" || approvers.approver2 == null) {
        form.set(Form.target.VALUE, [
          "approverDistro2",
          typeof approvers.approver2 != "undefined" && approvers.approver2
            ? 0
            : approvers.approverDistro2,
        ]);
      } else {
        console.log("approverDistro2 - empty 1");
        form.set(Form.target.VALUE, ["approverDistro2", 0]);
      }
      if (approvers.approver3 === "" || approvers.approver3 == null) {
        //setSelectedApproverDistro2(approvers.approverDistro2);
        form.set(Form.target.VALUE, [
          "approverDistro3",
          approvers.approverDistro3,
        ]);
      } else {
        form.set(Form.target.VALUE, ["approverDistro3", 0]);
      }
      if (approvers.approver4 === "" || approvers.approver4 == null) {
        form.set(Form.target.VALUE, [
          "approverDistro4",
          approvers.approverDistro4,
        ]);
      } else {
        form.set(Form.target.VALUE, ["approverDistro4", 0]);
      }

      // check if both empty approver distro and approver
      if (!approvers.approver2 && !approvers.approverDistro2) {
        form.set(Form.target.VALUE, ["approverDistro2", 0]);
      }
      if (!approvers.approver3 && !approvers.approverDistro3) {
        form.set(Form.target.VALUE, ["approverDistro3", 0]);
      }
      if (!approvers.approver4 && !approvers.approverDistro4) {
        form.set(Form.target.VALUE, ["approverDistro4", 0]);
      }
    }
  }, [approvers]);

  useEffect(() => {
    if (selectedApproverDistro2) {
      console.log("set empty distro 2");
      form.set(Form.target.VALUE, ["approver2", ""]);
      validate(["approver2", form.values.approver2]).then(([name, error]) => {
        form.set(Form.target.ERROR, [name, error]);
      });
    }
    if (selectedApproverDistro3) {
      form.set(Form.target.VALUE, ["approver3", ""]);
      validate(["approver3", form.values.approver3]).then(([name, error]) => {
        form.set(Form.target.ERROR, [name, error]);
      });
    }
    if (selectedApproverDistro4) {
      form.set(Form.target.VALUE, ["approver4", ""]);
      validate(["approver4", form.values.approver4]).then(([name, error]) => {
        form.set(Form.target.ERROR, [name, error]);
      });
    }
  }, [
    selectedApproverDistro2,
    selectedApproverDistro3,
    selectedApproverDistro4,
  ]);

  const [pending, setPending] = React.useState(false);
  const [level, setLevel] = React.useState<string>("");
  const [disabledDelete, setDisabledDelete] = React.useState(false);
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = React.useState<
    boolean
  >(false);

  const [directory_users, , directory_users_fetching] = Hooks.useDirectory(
    form.values?.approver1 ? form.values.approver1 : ""
  );

  const [directory_users2, , directory_users_fetching2] = Hooks.useDirectory(
    form.values?.approver2 ? form.values.approver2 : ""
  );

  const [directory_users3, , directory_users_fetching3] = Hooks.useDirectory(
    form.values?.approver3 ? form.values.approver3 : ""
  );

  const [directory_users4, , directory_users_fetching4] = Hooks.useDirectory(
    form.values?.approver4 ? form.values.approver4 : ""
  );

  let approverDistroMenu = null;
  if (isFetchingApproverDistros) {
    approverDistroMenu = <MenuItem value={0}>Please wait...</MenuItem>;
  } else {
    approverDistroMenu = approverDistros.map((item: any, key) => (
      <MenuItem key={key} value={item.value}>
        {item.label}
      </MenuItem>
    ));
  }

  function removeApproverValidation() {
    if (!isValidEmail(form.values.approver1)) {
      form.values.approver1 = "";
      validate(["approver1", form.values.approver1]).then(([name, error]) => {
        form.set(Form.target.ERROR, [name, error]);
      });
    }
    if (!isValidEmail(form.values.approver2)) {
      form.values.approver2 = "";
      validate(["approver2", form.values.approver2]).then(([name, error]) => {
        form.set(Form.target.ERROR, [name, error]);
      });
    }
    if (!isValidEmail(form.values.approver3)) {
      form.values.approver3 = "";
      validate(["approver3", form.values.approver3]).then(([name, error]) => {
        form.set(Form.target.ERROR, [name, error]);
      });
    }
    if (!isValidEmail(form.values.approver4)) {
      form.values.approver4 = "";
      validate(["approver4", form.values.approver4]).then(([name, error]) => {
        form.set(Form.target.ERROR, [name, error]);
      });
    }
  }

  function validate([name, value]: [string, any]): Promise<
    [keyof FormValues, Error?]
  > {
    let error: Error | undefined;

    switch (name) {
      case "approver1":
        if (value) {
          return Promise.resolve([
            name as Key,
            Form.Validators.isEmail(value as string),
          ]);
        } else {
          return Promise.resolve([name as Key]);
        }
      case "approver2":
        if (value) {
          return Promise.resolve([
            name as Key,
            Form.Validators.isEmail(value as string),
          ]);
        } else {
          return Promise.resolve([name as Key]);
        }
      case "approver3":
        if (value) {
          return Promise.resolve([
            name as Key,
            Form.Validators.isEmail(value as string),
          ]);
        } else {
          return Promise.resolve([name as Key]);
        }
      case "approver4":
        if (value) {
          return Promise.resolve([
            name as Key,
            Form.Validators.isEmail(value as string),
          ]);
        } else {
          return Promise.resolve([name as Key]);
        }
      default:
        return Promise.resolve([name as Key]);
    }

    return Promise.resolve([name as keyof FormValues, error]);
  }

  function getDirectoryOptions(level: string): string[] {
    let ret: string[] = [];
    switch (level) {
      case "1":
        ret = directory_users ? directory_users.map((user) => user.email) : [];
        break;
      case "2":
        ret = directory_users2
          ? directory_users2.map((user) => user.email)
          : [];
        break;
      case "3":
        ret = directory_users3
          ? directory_users3.map((user) => user.email)
          : [];
        break;
      case "4":
        ret = directory_users4
          ? directory_users4.map((user) => user.email)
          : [];
        break;
    }

    return ret;
  }

  useEffect(() => {
    (async () => {
      try {
        const details = await getEmployeeByEmail(userEmail ? userEmail : "");
        setUserDetails(details);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [userEmail]);

  function onChange(name: Key, value: any): void {
    if (name === "approver2") {
      console.log("approverDistro2 - empty");
      form.set(Form.target.VALUE, ["approverDistro2", 0]);
      setSelectedApproverDistro2(0);
    }
    if (name === "approver3") {
      form.set(Form.target.VALUE, ["approverDistro3", 0]);
      setSelectedApproverDistro3(0);
    }
    if (name === "approver4") {
      form.set(Form.target.VALUE, ["approverDistro4", 0]);
      setSelectedApproverDistro4(0);
    }

    form.set(Form.target.VALUE, [name, value]);
    validate([name, value]).then(([name, error]) => {
      form.set(Form.target.ERROR, [name, error]);
    });
  }

  const handleApproverDistroTypeChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    form.set(Form.target.VALUE, [name, value]);
    if (name === "approverDistro2") setSelectedApproverDistro2(value);
    if (name === "approverDistro3") setSelectedApproverDistro3(value);
    if (name === "approverDistro4") setSelectedApproverDistro4(value);
  };

  function handleApproversUpdateClick(): void {
    removeApproverValidation(); // will clear the validation if the input has invalid email empty.
    setPending(true);
    updateApproversRequest(headerId, {
      ...form.values,
    })
      .then((response) => {
        setPending(false);
        form.reset();
        setValues(undefined);
        setSelectedApproverDistro2(0);
        setSelectedApproverDistro3(0);
        setSelectedApproverDistro4(0);
        if (response) {
          onUpdate();
          alertService.success({
            msg: "Approver(s) has been successfully updated.",
          });
        } else {
          alertService.danger({
            msg: "Failed to update approver(s)",
          });
        }
        clearAndClose();
      })
      .catch((error) => {
        setPending(false);
        console.log("Error: Update Approvers. " + error);
      });
  }

  function handleApproversRemoveClick(level: string): void {
    setDisabledDelete(true);
    removeApproverRequest(headerId, level)
      .then((response) => {
        setDisabledDelete(false);
        form.reset();
        setValues(undefined);
        setSelectedApproverDistro2(0);
        setSelectedApproverDistro3(0);
        setSelectedApproverDistro4(0);
        setIsOpenConfirmationModal(false);
        if (response) {
          onUpdate();
          alertService.success({
            msg: "Approver has been successfully deleted.",
          });
        } else {
          alertService.danger({
            msg: "Failed to delete approver(s)",
          });
        }
        closeModal();
      })
      .catch((error) => {
        setDisabledDelete(false);
        console.log("Error: Remove Approvers. " + error);
      });
  }

  function handleEmailValueInput(name: Key, value: string): void {
    form.set(Form.target.VALUE, [name, value]);
    validate([name, value]).then(([name, error]) => {
      form.set(Form.target.ERROR, [name, error]);
    });
  }

  function isValidEmail(email: any) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  function clearAndClose() {
    form.reset();
    setSelectedApproverDistro2(0);
    setSelectedApproverDistro3(0);
    setSelectedApproverDistro4(0);
    setIsOpenConfirmationModal(false);
    setValues(undefined);
    closeModal();
  }

  console.log("approverDistro2 - "+form.values.approverDistro2);

  return (
    <Modal
      isOpen={isOpen}
      title={`${title}`}
      size="lg"
      closeModal={() => clearAndClose()}
    >
      <Modal
        isOpen={isOpenConfirmationModal}
        positionButton="center"
        actions={[
          {
            label: "Cancel",
            variant: "outlined",
            handler: () => {
              setIsOpenConfirmationModal(false);
            },
          },
          {
            label: pending ? "Submitting..." : "Submit",
            handler: () => {
              handleApproversRemoveClick(level);
            },
            disabled: pending,
          },
        ]}
      >
        <Typography align="center" paragraph>
          Are you sure you want to remove Approver(s)?
        </Typography>
      </Modal>
      <DialogContent>
        <Box className={classNames.dialogContent}>
          <Grid item xs={12}>
            <Form>
              <Form.Textbox
                disabled
                label="Approver 1"
                name="oldApprover1"
                size={4}
                value={approvers.approver1 ? approvers?.approver1 : ""}
              />
              <Form.Autocomplete
                error={form.errors.approver1}
                label="New Approver 1"
                loading={directory_users_fetching}
                name="approver1"
                onChange={onChange}
                onInput={handleEmailValueInput}
                options={getDirectoryOptions("1")}
                size={4}
                value={""}
              />
            </Form>
          </Grid>
          <Grid item xs={12}>
            <Form>
              <Form.Textbox
                disabled
                label="Approver 2"
                name="oldApprover2"
                size={3}
                value={approvers.approver2 ? approvers?.approver2 : ""}
              />
              <Form.Autocomplete
                error={form.errors.approver2}
                label="New Approver 2"
                loading={directory_users_fetching2}
                name="approver2"
                onChange={onChange}
                onInput={handleEmailValueInput}
                options={getDirectoryOptions("2")}
                size={3}
                value={form.values?.approver2 || ""}
              />
              <Field label="Approver Distro 2" size={3}>
                <Select
                  name="approverDistro2"
                  value={form.values.approverDistro2}
                  onChange={handleApproverDistroTypeChange}
                  disabled={isFetchingApproverDistros}
                >
                  {approverDistroMenu}
                </Select>
              </Field>
              <IconButton
                size="small"
                disabled={!approvers.approver2 && !approvers.approverDistro2}
                onClick={() => {
                  setLevel("2nd");
                  setIsOpenConfirmationModal(true);
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Form>
          </Grid>
          <Grid item xs={12}>
            <Form>
              <Form.Textbox
                disabled
                label="Approver 3"
                name="oldApprover3"
                size={3}
                value={approvers.approver3 ? approvers?.approver3 : ""}
              />
              <Form.Autocomplete
                error={form.errors.approver3}
                label="New Approver 3"
                loading={directory_users_fetching3}
                name="approver3"
                onChange={onChange}
                onInput={handleEmailValueInput}
                options={getDirectoryOptions("3")}
                size={3}
                value={form.values?.approver3 || ""}
              />
              <Field label="Approver Distro 3" size={3}>
                <Select
                  name="approverDistro3"
                  value={form.values.approverDistro3}
                  onChange={handleApproverDistroTypeChange}
                  disabled={isFetchingApproverDistros}
                >
                  {approverDistroMenu}
                </Select>
              </Field>
              <IconButton
                size="small"
                disabled={!approvers.approver3 && !approvers.approverDistro3}
                onClick={() => {
                  setLevel("3rd");
                  setIsOpenConfirmationModal(true);
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Form>
          </Grid>
          <Grid item xs={12}>
            <Form>
              <Form.Textbox
                disabled
                label="Approver 4"
                name="oldApprover4"
                size={3}
                value={approvers.approver4 ? approvers?.approver4 : ""}
              />
              <Form.Autocomplete
                error={form.errors.approver4}
                label="New Approver 4"
                loading={directory_users_fetching4}
                name="approver4"
                onChange={onChange}
                onInput={handleEmailValueInput}
                options={getDirectoryOptions("4")}
                size={3}
                value={form.values?.approver4 ? form.values.approver4 : ""}
              />
              <Field label="Approver Distro 4" size={3}>
                <Select
                  name="approverDistro4"
                  value={form.values.approverDistro4}
                  onChange={handleApproverDistroTypeChange}
                  disabled={isFetchingApproverDistros}
                >
                  {approverDistroMenu}
                </Select>
              </Field>
              <IconButton
                size="small"
                disabled={!approvers.approver4 && !approvers.approverDistro4}
                onClick={() => {
                  setLevel("4th");
                  setIsOpenConfirmationModal(true);
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Form>
          </Grid>
          <Box m={1}></Box>
          <CardWrapper title="User Details">
            <Box p={3}>
              <Grid container direction="row">
                <Grid item xs={12}>
                  <Typography variant="subtitle1">
                    <b>{userDetails?.email}</b>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2">
                    <span>
                      <b>Manager:</b>
                    </span>{" "}
                    {userDetails?.managerEmail}
                  </Typography>
                  <Typography variant="body2">
                    <span>
                      <b>VP:</b>
                    </span>{" "}
                    {userDetails?.vpemail}
                  </Typography>
                  <Typography variant="body2">
                    <span>
                      <b>SVP:</b>
                    </span>{" "}
                    {userDetails?.svpemail}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </CardWrapper>
          <Box textAlign="right" mt={4}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => clearAndClose()}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="button"
              onClick={() => handleApproversUpdateClick()}
              style={{ marginLeft: "40px" }}
              disabled={pending}
            >
              {pending ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Modal>
  );
};
